import PageHero from '../../components/PageHero';
import './WhyWeddingzVenuePage.css';
import founderImage from '../../../assets/image.png';

function WhyWeddingzVenuePage() {
  return (
    <div className="why-weddingzvenue-page content-page">
      <PageHero
        title="Why Us - The Inspiring Story of Weddingzvenue.in"
        subtitle="Everything your wedding needs, all in one place"
      />
      <div className="why-weddingzvenue-container content-container">
        <section className="why-story-card">
          <p>Every great platform begins with a vision.</p>
          <p>
            In India, weddings are not just ceremonies - they are once-in-a-lifetime celebrations
            filled with emotions, traditions, and unforgettable memories. Families dream of creating
            the perfect wedding, but the reality is often very different.
          </p>
          <p>
            Finding the right venue, searching for trusted vendors, arranging photographers, makeup
            artists, caterers, band, hotel rooms, and many other services becomes a stressful and
            time-consuming process. People travel from place to place, make countless calls, and
            still struggle to organize everything perfectly.
          </p>
          <p>This challenge gave birth to an idea.</p>
          <p>
            The idea was simple but powerful - what if everything related to weddings could be found
            on one single platform?
          </p>
          <div className="why-founder-highlight">
            <figure className="why-founder-figure">
              <div className="why-founder-image-crop">
                <img
                  src={founderImage}
                  alt="Founder Abdul Kareem speaking at an event"
                  className="why-founder-image"
                />
              </div>
              <figcaption className="why-founder-caption">
                Founder Abdul Kareem - The vision behind Weddingzvenue.in
              </figcaption>
            </figure>
            <div className="why-founder-text">
              <p>
                This vision was brought to life by Founder Abdul Kareem, who believed that wedding
                planning should be simple, organized, and accessible for everyone.
              </p>
              <p>
                With determination and a dream to simplify wedding planning in India, Weddingzvenue.in
                was created.
              </p>
            </div>
          </div>
          <p>
            Weddingzvenue.in is not just another listing website. It is a complete wedding discovery
            platform designed to bring every wedding service together in one place.
          </p>

          <h2>What You Can Find on Weddingzvenue.in</h2>
          <ul className="why-services-list">
            <li>Stunning Wedding Venues and Banquet Halls</li>
            <li>Trusted Wedding Vendors</li>
            <li>Professional Photographers and Videographers</li>
            <li>Experienced Makeup Artists</li>
            <li>Creative Mehndi Artists</li>
            <li>Grand Band Baja and Wedding Processions</li>
            <li>Royal Baggi Services</li>
            <li>Delicious Catering Services</li>
            <li>Stylish Fog Entry and Ramp Walk Event Setup</li>
            <li>Comfortable Hotel Rooms for Wedding Guests</li>
          </ul>

          <p>
            Instead of searching different places for different services, families can now discover
            everything they need on one single platform.
          </p>
          <p>
            But the mission of Weddingzvenue.in goes beyond helping customers. Thousands of banquet
            halls and wedding vendors across India struggle to get the online visibility they
            deserve. Many amazing venues and talented vendors remain unnoticed simply because they
            lack strong digital presence.
          </p>
          <p>
            Weddingzvenue.in empowers them. We help banquet halls and wedding vendors grow their
            business through digital promotion, online presence, and access to genuine customers who
            are actively searching for wedding services.
          </p>
          <p>What started as a simple idea is now becoming a powerful mission.</p>

          <div className="why-mission-vision">
            <div className="why-focus-card">
              <h3>Our Mission</h3>
              <p>
                To simplify wedding planning by bringing all wedding services together on one trusted
                platform.
              </p>
            </div>
            <div className="why-focus-card">
              <h3>Our Vision</h3>
              <p>
                To become India&apos;s most trusted and largest wedding discovery platform.
              </p>
            </div>
          </div>

          <p>
            Founder Abdul Kareem believes that technology can transform how weddings are planned in
            India - making the process easier for families and more rewarding for venue owners and
            vendors.
          </p>
          <p>
            Weddingzvenue.in is more than a website. It is a growing movement that connects
            celebrations, venues, and wedding professionals across India.
          </p>
          <p>
            Because every wedding deserves the perfect venue, the perfect team, and the perfect
            beginning.
          </p>
          <p className="why-tagline">
            Weddingzvenue.in - Everything Your Wedding Needs, All in One Place.
          </p>
        </section>
      </div>
    </div>
  );
}

export default WhyWeddingzVenuePage;
